module.exports = __webpack_public_path__ + "static/media/02.ce7a69af.png";